export default function(instance) {
  return {
    getAllTickets(data) {
      return instance.get("/api/applications/admin/", {
        params: data ? data : ""
      });
    },
    createTicket(data) {
      return instance.post("/api/applications/admin/", {
        theme: data.theme,
        body: data.body,
        user: data.user
      });
    },
    getTicket(idTicket) {
      return instance.get(`/api/applications/admin/${idTicket}/`);
    },
    deleteTicket(idTicket) {
      return instance.delete(`/api/applications/admin/${idTicket}/`);
    },
    updateStatusTicket(idTicket, data) {
      return instance.put(`/api/applications/admin/${idTicket}/`, {
        status: data.status
      });
    },
    updateVisibleTicket(idTicket, data) {
      return instance.put(`/api/applications/admin/${idTicket}/`, {
        is_hidden: data.is_hidden
      });
    },
    updatePriceTicket(idTicket, data) {
      return instance.put(`/api/applications/admin/${idTicket}/`, {
        price: data.price
      });
    },
    sendMessage(data) {
      return instance.post("/api/applications/messages/admin/", {
        from_user: data.from_user,
        text: data.text,
        chat: data.chat
      });
    },
    deleteMessage(idMessage) {
      return instance.delete(`/api/applications/messages/admin/${idMessage}`);
    }
  };
}
